import { Users, ListChecks, Sparkles, Wallet } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { EVENT_STATUS, eur, fmtDate, fmtTs, TASK_STATUS } from "@/manager/lib";
import { Card } from "@/manager/ui";

function Box({ icon: Icon, title, children, onClick, testid, alert }) {
  return (
    <button onClick={onClick} data-testid={testid} className={`text-left bg-white border rounded-2xl p-5 hover:shadow-sm transition-shadow ${alert ? "border-rose-300" : "border-[#e6e1d6]"}`}>
      <p className="flex items-center gap-2 text-[11px] uppercase tracking-[0.16em] text-[#6b6a66] mb-3"><Icon size={14} /> {title}</p>
      {children}
    </button>
  );
}

export default function SummaryTab({ ev, save, goTab }) {
  const st = ev.staff;
  const open = ev.tasks.filter((t) => ["pendiente", "en_curso"].includes(t.status));
  const f = ev.finance_summary;
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        <Box icon={Users} title="Personal" onClick={() => goTab("personal")} testid="sum-staff" alert={st.missing > 0}>
          <p className="font-display text-3xl">{st.confirmed}/{st.needed}</p>
          <p className="text-xs text-[#6b6a66]">confirmados · recomendado {st.recommended} · asignados {st.assigned}</p>
          {st.missing > 0 && <p className="text-xs text-rose-600 mt-1">Faltan {st.missing} por confirmar</p>}
        </Box>
        <Box icon={ListChecks} title="Tareas" onClick={() => goTab("tareas")} testid="sum-tasks" alert={open.length > 0}>
          <p className="font-display text-3xl">{open.length}</p>
          <p className="text-xs text-[#6b6a66]">abiertas de {ev.tasks.length}</p>
        </Box>
        <Box icon={Sparkles} title="Limpieza" onClick={() => {}} testid="sum-cleaning">
          <p className="font-display text-xl">{ev.cleaning ? ev.cleaning.status : "No aplica"}</p>
          {ev.cleaning && <p className="text-xs text-[#6b6a66]">{fmtDate(ev.cleaning.date)} {ev.cleaning.time} · {ev.cleaning.assignee || "sin responsable"}</p>}
        </Box>
        <Box icon={Wallet} title="Economía" onClick={() => goTab("finanzas")} testid="sum-finance">
          <p className="font-display text-xl">{eur(f.collected)} <span className="text-sm text-[#6b6a66]">/ {eur(f.income_expected)}</span></p>
          <p className="text-xs text-[#6b6a66]">margen real {eur(f.margin_real)}</p>
        </Box>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="p-5 text-sm space-y-2">
          <h3 className="font-display text-lg mb-2">Datos generales</h3>
          <p><span className="text-[#6b6a66]">Cliente:</span> {ev.client_name || "—"} {ev.client_phone && `· ${ev.client_phone}`} {ev.client_email && `· ${ev.client_email}`}</p>
          <p><span className="text-[#6b6a66]">Tipo:</span> {ev.event_type || "—"}</p>
          <p><span className="text-[#6b6a66]">Montaje:</span> {ev.setup_time || "—"} · <span className="text-[#6b6a66]">Celebración:</span> {ev.start_time || "--"}–{ev.end_time || "--"}</p>
          <div className="flex items-center gap-3 pt-2">
            <span className="text-[#6b6a66]">Estado:</span>
            <Select value={ev.status} onValueChange={(v) => save({ status: v }, "Estado actualizado")}>
              <SelectTrigger className="w-44 h-8" data-testid="sum-status"><SelectValue /></SelectTrigger>
              <SelectContent>{Object.entries(EVENT_STATUS).map(([k, s]) => <SelectItem key={k} value={k}>{s.label}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          {ev.external_source && <p className="text-xs text-[#6b6a66] pt-2">Última sincronización: {fmtTs(ev.last_synced_at)}</p>}
        </Card>
        <Card className="p-5">
          <h3 className="font-display text-lg mb-3">Próximas tareas</h3>
          {open.slice(0, 6).map((t) => (
            <p key={t.id} className="text-sm flex justify-between py-1 border-b border-[#f0ece4] last:border-0">
              <span>{t.title}</span><span className="text-xs text-[#6b6a66]">{fmtDate(t.due_date)} · {TASK_STATUS[t.status]}</span>
            </p>
          ))}
          {!open.length && <p className="text-sm text-emerald-700">Sin tareas abiertas.</p>}
        </Card>
      </div>
    </div>
  );
}
